import { CheckCircle } from 'ui/icons';

interface IProps {
  icon: JSX.Element;
  message: string;
}

const AdditionNotAllowed = ({ icon, message }: IProps) => {
  return (
    <div className="flex items-center justify-center h-[100%]">
      <div className="flex flex-col items-center justify-center gap-6">
        <span>
          {icon}
          <CheckCircle
            className="relative bottom-6 left-16"
            height={24}
            width={24}
            stroke="#BFF3EA"
            fill="#4E9594"
            color="white"
            pathStroke="#FFFFFF"
          />
        </span>
        <p className="text-center font-body font-normal text-gray-600 text-base lg:w-full w-[70%]">
          {message}
        </p>
      </div>
    </div>
  );
};

export default AdditionNotAllowed;
